// extracted by mini-css-extract-plugin
export default {"introductionContainer":"intro_introductionContainer__mODf2","imageContainer":"intro_imageContainer__9m96o"};